import { useEffect } from 'react';
import { DatarouterError } from '@zg-rentals/web-base';
import { useToast } from '@zillow/constellation';

import UnmaskedToast from '../components/UnmaskedToast';

export const useErrorHandler = ({ isError, error }: { isError: boolean; error: unknown }) => {
  const { enqueueToast } = useToast();

  useEffect(() => {
    if (isError) {
      enqueueToast(<UnmaskedToast appearance="error" body={DatarouterError.getDisplayMessage(error)} />);
    }
  }, [isError, enqueueToast, error]);
};
